import { createAction } from '@reduxjs/toolkit';
import { CLEAR_SEARCHER_FILTERS_ON_SET_TABS } from '../constants/extraItems';

export const clearSearcherFiltersActionInSetTab = createAction(
  CLEAR_SEARCHER_FILTERS_ON_SET_TABS,
);
